import React, { useEffect } from "react";

const FokusKonten: React.FC = () => {
  useEffect(() => {
    const elements = document.querySelectorAll(".reveal");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate-fadeUp");
          }
        });
      },
      { threshold: 0.15 }
    );

    elements.forEach((el) => observer.observe(el));
  }, []);

  const fokusKonten = [
    {
      title: "Program Presiden",
      desc: "Mengawal dan menyebarluaskan program strategis Presiden Prabowo Subianto kepada masyarakat luas.",
      icon: "🇮🇩",
    },
    {
      title: "Program KSP",
      desc: "Menyajikan informasi dan perkembangan program Kantor Staf Presiden secara cepat dan mudah dipahami.",
      icon: "🏛️",
    },
    {
      title: "Nasionalisme",
      desc: "Mengedukasi publik mengenai kedaulatan bangsa, persatuan nasional, dan kepentingan negara.",
      icon: "🦅",
    },
    {
      title: "Ekonomi Rakyat",
      desc: "Mengangkat isu ekonomi kerakyatan, pemberdayaan UMKM, serta upaya mencegah kebocoran negara.",
      icon: "📈",
    },
    {
      title: "Isu Strategis",
      desc: "Memberikan respons terhadap isu oligarki, media asing, dan berbagai narasi yang memengaruhi kepentingan nasional.",
      icon: "🎯",
    },
    {
      title: "Konten Viral Politik",
      desc: "Mengemas potongan pidato tokoh nasional dan isu politik dalam format reels serta shorts yang mudah dibagikan.",
      icon: "🎬",
    },
  ];

  return (
    <section className="bg-white pt-5 pb-20 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <span className="inline-flex items-center px-4 py-2 rounded-full bg-gray-100 text-gray-700 text-sm font-medium">MERAH PUTIH 08</span>

          <h2 className="mt-5 text-4xl md:text-5xl font-bold text-gray-900">
            Fokus <span className="text-[#7a0f1e]">Konten</span>
          </h2>

          <p className="mt-4 text-gray-600 max-w-3xl mx-auto">
            Menjadi media digital yang aktif mengawal program pemerintah, memperkuat narasi kebangsaan, serta menghadirkan informasi politik dan ekonomi secara cepat, relevan, dan mudah dipahami masyarakat.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {fokusKonten.map((item, index) => (
            <div key={index} className="group relative bg-white border border-gray-200 rounded-3xl p-8 hover:shadow-2xl hover:-translate-y-2 transition-all duration-300">
              {/* Top Accent */}
              {/* <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-red-500 to-red-800 rounded-t-3xl"></div> */}

              <div className="text-5xl mb-5">{item.icon}</div>

              <h3 className="text-xl font-bold text-gray-900 mb-3">{item.title}</h3>

              <p className="text-gray-600 leading-relaxed">{item.desc}</p>

              {/* <div className="mt-6 text-sm font-semibold text-[#7a0f1e] opacity-0 group-hover:opacity-100 transition">Selengkapnya →</div> */}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FokusKonten;
